<template>
  <new-layout class="relative j_affix_relative background-white">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/company/information">邮轮资讯</el-breadcrumb-item>
        <el-breadcrumb-item>内容详情</el-breadcrumb-item>
      </el-breadcrumb>
    </template>

    <div class="w-[858px]">
      <article :class="$style.articleContent">
        <template v-if="state.type != 2">
          <!-- 标题 -->
          <div class="article-title text-dark mb-5 text-3xl font-semibold">
            {{ content.title }}
          </div>

          <div class="flex my-5 text-base items-center text-[#606060]">
            <!-- <el-tag class="font-medium rounded-sm py-0" size="mini" type="warning" effect="plain">推荐</el-tag> -->
            <!-- <span class="text-dark"> -->
            <span v-if="state.author_info.author_name">来自主体：{{ state.author_info.author_name }}｜</span>
            <span v-if="state.source">{{ state.source }}</span>
            <!-- </span> -->
            <span v-if="state.pageviews > 0" class="ml-4">{{ state.pageviews }}次阅读</span>
            <span class="ml-4">{{ state.create_time }}</span>
          </div>
          <!-- 翻译 -->
          <div class="flex text-lg mb-[40px] text-sx" v-if="state.has_original == 1">
            <div class="flex items-center text-dark mr-[12px]">
              <i class="ficon ficon-fanyi mr-[10px]"></i>
              <span v-if="translateLoading">语言切换中，请稍后...</span>
              <span v-else>{{ showOriginal ? '当前内容为原文' : '当前内容已翻译成中文' }}</span>
            </div>
            <span class="text-primary font-500 cursor-pointer select-none" @click="toggleShowOriginal">{{
              showOriginal ? '一键翻译' :
              '查看原文'
            }}</span>
          </div>
        </template>
        <client-only>
          <div v-if="state.video" class="mb-5">
            <v-player :src="state.video" :cover="state.video_cover" />
          </div>
        </client-only>
        <template v-if="state.type == 2">
          <div class="article-title text-dark mb-5 text-3xl font-semibold">
            {{ content.title }}
          </div>

          <div class="flex my-5 text-base items-center text-[#606060]">
            <span v-if="state.author_info.author_name">来自主体：{{ state.author_info.author_name }}｜</span>
            <span v-if="state.source">{{ state.source }}</span>
            <!-- </span> -->
            <span v-if="state.pageviews > 0" class="ml-4">{{ state.pageviews }}次阅读</span>
            <span class="ml-4">{{ state.create_time }}</span>
          </div>
          <div v-if="state.summary">{{ state.summary }}</div>
        </template>
        <div v-if="state.voice" class="audio mt-3 mb-1">
          <client-only>
            <a-player :src="state.voice" />
          </client-only>
        </div>

        <EditorContent v-if="state.type != 2" class="article-content whitespace-pre-wrap break-all"
          :content="content.content" />
      </article>

      <div v-if="consultations.length" class="mt-8">
        <div class="recommends">
          <h2 class="text-dark mb-4 text-3xl font-semibold flex items-center">
            <span>相关推荐</span>
          </h2>
        </div>
        <el-row type="flex" class="consultations flex-wrap" :gutter="10">
          <el-col class="mb-7" v-for="item in consultations" :key="item.no" :span="6">
            <InformationCard :report="item" :isVideo="item.type == 2" />
          </el-col>
        </el-row>
        <client-only v-if="isMounted">
          <div>
            <infinite-loading ref="infiniteLoading" :on-infinite="infiniteHandler">
              <div slot="no-more">没有更多了</div>
              <div class="py-4" slot="spinner">正在加载...</div>
            </infinite-loading>
          </div>
        </client-only>
      </div>

      <div :class="$style.tools">
        <div :class="[$style.tools__item, isLike ? $style.is_active : '']" @click="onLike">
          <div :class="$style.tools__item__icon">
            <i class="ficon ficon-dianzan1 text-[24px]" />
          </div>
          <div :class="$style.tools__item__text">{{ likeNum ? likeNum : '点赞' }}</div>
        </div>
        <el-popover trigger="hover" placement="right">
          <el-image class="w-[148px] h-[148px]" fit="cover" :src="state.h5_code_url" />
          <p class="text-center mt-2">微信扫码分享</p>
          <div slot="reference" :class="$style.tools__item" class="mt-4">
            <div :class="$style.tools__item__icon">
              <i class="ficon ficon-xingzhuangjiehe2" />
            </div>
            <div :class="$style.tools__item__text">{{ state.forward ? state.forward : '分享' }}</div>
          </div>
        </el-popover>
        <!-- <el-divider class="my-4 w-7" />
        <div :class="$style.tools__item" @click="visible = true">
          <div :class="$style.tools__item__icon" class="group-hover:text-primary">
            <i class="ficon ficon-sousuo" />
          </div>
          <div :class="$style.tools__item__search" class="group-hover:text-primary">
            搜索
          </div>
        </div>
      </div>
      </v-affix> -->
      </div>
    </div>
    <template #aside>
      <consultation-aside type="28" :articleId=$route.params.articleId :recommendList="recommendList" :relationData="state.relation" />
      <!-- <consultation-aside :type="isPopular ? 29 : 28" :articleId=$route.params.articleId :recommendList="recommendList"/> -->
      <div v-if="state.relation.length" :class="$style.relation">
        <!-- <h2 class="flex mb-3">
          <span class="text-dark font-semibold text-2xl"
            >文中关联信息</span
          >
        </h2> -->
        <div v-for="(item, index) in state.relation" :key="index">
          <!-- <div :class="$style.relation__brand" v-if="item.template === 'brand'">
            <div
              v-for="brand in item.data"
              :key="brand.id"
              :class="$style.relation__brand__item"
            >
              <nuxt-link class="flex flex-col items-center" :to="brand.to || '/'" target="_blank">
                <el-image class="h-9" :src="brand.image" fit="cover" />
                <span class="text-sm">{{ brand.name }}</span>
              </nuxt-link>
            </div>
          </div> -->
          <affiliated-brand-table v-if="item.template === 'brand'" :brands="item.data" title="文中关联信息" />
          <div v-if="item.template === 'cruise'" :class="$style.relation__cruise">
            <v-responsive class="my-4" :class="$style.relation__cruise__item" v-for="(cruise, cruiseIndex) in item.data"
              :key="cruiseIndex" :aspectRatio="262 / 148">
              <nuxt-link :to="cruise.to || '/'" target="_blank">
                <el-image class="absolute inset-0 rounded" fit="cover" :src="cruise.image" />
                <div :class="$style.relation__cruise__item__footer">
                  {{ cruise.name }}
                </div>
              </nuxt-link>
            </v-responsive>
          </div>
        </div>
      </div>
    </template>
    <AppDock />
  </new-layout>
</template>
<script>
import APlayer from "@/components/APlayer/index.vue";
import VResponsive from "~/components/VResponsive/VResponsive.vue";
import VAffix from "@/components/VAffix/index.js";
import EditorContent from "~/components/Ckeditor/EditorContent.vue";
import VPlayer from "~/components/VPlayer/index.vue";
import ConsultationAside from "@/views/company/ConsultationAside.vue";
import InformationCard from "@/views/company/InformationCard.vue";
import NewLayout from "~/views/company/NewLayout.vue";
import SearchDialog from "~/views/company/SearchDialog.vue";
import SearchRec from "@/views/company/SearchRec.vue";
import AffiliatedBrandTable from "@/views/company/AffiliatedBrandTable.vue";
import AppDock from '~/components/layouts/AppDock.vue'

import {
  ref,
  useFetch,
  useMeta,
  useRoute,
  defineComponent,
  computed,
  onBeforeMount
} from "@nuxtjs/composition-api";
import useRequest from "~/composables/useRequest";

// api
import {
  getArticleOriginalDetail,
  getArticleDetail,
  searchCommunity,
  updateRecordNum,
} from "~/services/company";

import { useToggle, useMounted } from "@vueuse/core";
import { isError } from "lodash";
import useMessage from "~/composables/useMessage";
import usePagination from "~/composables/usePagination";

import { REQUEST_CODES } from "~/constants/const-http";

function useLike() {
  const likeNum = ref(0);
  const [isLike, toggle] = useToggle(false);
  const message = useMessage();
  const route = useRoute();
  const visible = ref(false);

  async function onLike() {
    try {
      // console.log(error.value);
      if (isLike.value) {
        return;
      }
      // await execute(0);
      const { code, data, msg } = await updateRecordNum({
        no: route.value.params.articleId,
        type: "like"
      });
      if (code !== REQUEST_CODES.ERROR_OK) {
        throw new Error(msg);
      }
      toggle(true);
      likeNum.value += 1;
    } catch (error) {
      console.error(error);
      isError(error) && message.error(error.message);
    }
  }
  return {
    visible,
    likeNum,
    isLike,
    onLike
  };
}

function useMoreContent(service) {
  const consultations = ref([]);
  const {
    execute,
    pagination,
    isLoading: isLoadingMore
  } = usePagination((...rest) => service(...rest), undefined, {
    immediate: false
  });
  pagination.page_size = 12;

  async function fetchList() {
    let data = await execute();
    consultations.value = consultations.value.concat(data.list);
    console.log("....... fetchList: consultations", consultations.value);
    return data;
  }

  async function onLoadMore() {
    pagination.page_index += 1;
    await fetchList();
  }

  return {
    fetchList,
    consultations,
    onLoadMore,
    isLoadingMore,
    pagination
  };
}

export default defineComponent({
  name: "Article",
  layout: "Main",
  auth: false,
  components: {
    InformationCard,
    SearchDialog,
    VAffix,
    NewLayout,
    APlayer,
    ConsultationAside,
    VResponsive,
    EditorContent,
    VPlayer,
    AffiliatedBrandTable,
    SearchRec,
    AppDock,
  },
  head: {},
  setup() {
    const route = useRoute();
    const { state, execute } = useRequest(
      () =>
        getArticleDetail({
          no: route.value.params.articleId
        }),
      {
        title: "",
        author_info: {},
        content: "",
        type: '',
        voice: "",
        relation: []
      },
      {
        immediate: false
      }
    );
    const { state: originalNewsInfo, execute: executeArticleOriginalDetail, isLoading: translateLoading } = useRequest(
      () =>
        getArticleOriginalDetail({
          no: route.value.params.articleId
        }),
      {
        title: "",
        author_info: {},
        content: "",
        type: '',
        voice: "",
        relation: []
      },
      {
        immediate: false
      }
    );

    const visible = ref(false);
    const { isLike, likeNum, onLike } = useLike();

    const { consultations, pagination, fetchList } =
      useMoreContent(({ page_index, page_size }) =>
        searchCommunity({
          no: route.value.params.articleId,
          cate: state.value.cate,
          page_index,
          page_size
        })
      );
    useFetch(async () => {
      await execute(0);
      // await fetchList();
      likeNum.value = state.value.likes;
    });
    onBeforeMount(async () => {
      await fetchList();
    })

    const firstLoad = ref(true);

    const isMounted = useMounted();
    const infiniteHandler = async function ($state) {
      if (firstLoad.value) {
        $state.loaded();
        firstLoad.value = false
        return
      }
      if (pagination.total_page > pagination.page_index) {
        pagination.page_index += 1;
        await fetchList()
        $state.loaded();
      } else {
        $state.complete();
      }
    }

    // 是否原创
    const isPopular = computed(() => {
      return state.value.cate === "original";
    });


    useMeta(() => ({
      title: `${state.value.title}上船吧全球邮轮资讯`,
      meta: [
        {
          name: "description",
          hid: "description",
          content: `${state.value.summary}`
        },
        {
          name: "keywords",
          hid: "keywords",
          content: `${state.value.keywords}`
        }
      ]
    }));

    return {
      visible,
      state,

      likeNum,
      isLike,
      onLike,

      consultations,

      isPopular,

      isMounted,

      translateLoading,
      originalNewsInfo,
      executeArticleOriginalDetail,
      infiniteHandler,
    };
  },
  data() {
    return {
      // translateLoading: false,
      showOriginal: false,
      // originalNewsInfo: {}
    }
  },
  computed: {
    content() {
      return {
        title: this.showOriginal ? this.originalNewsInfo.title : this.state.title,
        content: this.showOriginal ? this.originalNewsInfo.content : this.state.content,
      }
    },
    recommendList() {
      if (this.state.type == 2 && this.state.topic) {
        return this.state.topic
      }
      return []
    }
  },
  methods: {
    async toggleShowOriginal() {
      if (!this.showOriginal && !this.originalNewsInfo.content) {
        await this.executeArticleOriginalDetail()
      }
      this.showOriginal = !this.showOriginal
    }
  }
});
</script>
<style lang="scss" module>
.article_header {
  padding-top: 40px;
}
.authentication {
  border: 1px solid #F2B203;
}
.others {
  color: #C9CBD6;
}
.tools {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: end;
  -ms-flex-align: end;
  -webkit-align-items: flex-end;
  align-items: flex-end;
  position: fixed;
  width: 92px;
  left: 50%;
  top: var(--app-header-height);
  margin-top: 85px;
}
.tools:global(.affix) {
  position: fixed;
}
.tools:global(.affix-bottom) {
  position: absolute;
}
.tools__item {
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.tools__item__icon {
  font-size: 1.25rem;
  line-height: 1.75rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
  -webkit-transition-property: background-color, border-color, color, fill, stroke;
  -o-transition-property: background-color, border-color, color, fill, stroke;
  transition-property: background-color, border-color, color, fill, stroke;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
}
.tools__item.is_active .tools__item__icon {
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
.tools__item__text {
  font-size: 0.875rem;
  line-height: 1.25rem;
  margin-top: 0.25rem;
  --tw-text-opacity: 1;
  color: rgba(31, 33, 41, var(--tw-text-opacity));
}
.tools__item__search {
  margin-top: 0.25rem;
  --tw-text-opacity: 1;
  color: rgba(31, 33, 41, var(--tw-text-opacity));
}
.articleContent img {
  display: initial;
}
.relation {
  margin-bottom: 1.5rem;
}
.relation__brand {
  border-collapse: collapse;
  display: table;
  width: 100%;
}
.relation__brand__item {
  --tw-border-opacity: 1;
  border-color: rgba(227, 229, 239, var(--tw-border-opacity));
  border-width: 1px;
  display: table-cell;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.relation__cruise__item__footer {
  border-radius: 0.25rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  font-weight: 500;
  height: 2.75rem;
  padding-left: 12px;
  position: absolute;
  bottom: 0px;
  left: 0px;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  width: 100%;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
}
</style>
